$(function(){
    if($('.set_item').length > 0){

        $('.set_item').slice(1).each(function(){ 
            if($('.product_detail_set_wrap').length > 0){
                const detail_set_cont = $('.product_detail_set_wrap > div.product_set_wid').html();
                $('.product_detail_set_wrap').append('<div class="product_set_wid">' + detail_set_cont + '</div>');
            }
        });

        $('.set_item').each(function(){
            
            const set_item_name = $(this).attr('data-set-item-name');
            const set_item_desc = $(this).attr('data-set-item-desc');
            const set_item_usage = $(this).find('.usage').html();

            $('.accordion.exp .accordion__content').append('<div class="set_item_exp"><span class="if_you">'+set_item_name+'</span><span>'+set_item_desc+'</span></div>');
            $('.accordion.usage .accordion__content').append('<div class="set_item_usage"><span class="if_you">'+set_item_name+'</span><span class="usage">'+set_item_usage+'</span></div>');

        })

        $('.set_item').each(function(index) {
            const set_item_name = $(this).attr('data-set-item-name');
            const set_item_feat = $(this).attr('data-set-item-feat');
            const set_item_htu = $(this).attr('data-set-item-htu');
            const set_item_ingr = $(this).attr('data-set-item-ingr');
            const set_item_image = $(this).find('.set_item_image').html();
            
            $('.product_detail_set').eq(index).find('.product_name').text(set_item_name);
            $('.product_detail_set').eq(index).find('.feat p').html(set_item_feat);
            $('.product_detail_set').eq(index).find('.use p').html(set_item_htu);
            $('.product_detail_set').eq(index).find('.ingr p').html(set_item_ingr);
            $('.product_detail_set').eq(index).find('.swiper-wrapper').html(set_item_image);

            const use_text = $('.product_detail_set').eq(index).find('.use p').text().trim();
            const parts_1 = use_text.split('.').map(s => s.trim()).filter(Boolean);
            const wrapped_1 = parts_1.map(s => `<span class="how_to_use">${s}</span>`).join('');

            const feat_text = $('.product_detail_set').eq(index).find('.feat p').text().trim();
            const parts_2 = feat_text.split('.').map(s => s.trim()).filter(Boolean);
            const wrapped_2 = parts_2.map(s => `<span class="feat"><i class="circle"></i><text>${s}</text></span>`).join('');
            
            $('.product_detail_set').eq(index).find('.use p').html(wrapped_1);
            $('.product_detail_set').eq(index).find('.how_to_use').each(function() {
                $(this).prepend('<i>Step 0'+($(this).index() + 1)+'</i>')
            });

            $('.product_detail_set').eq(index).find('.feat p').html(wrapped_2);

        });

        
    }
})